import { render, staticRenderFns } from "./ModalContentEditProjectCommunities.vue?vue&type=template&id=022801ca&scoped=true&"
import script from "./ModalContentEditProjectCommunities.vue?vue&type=script&lang=js&"
export * from "./ModalContentEditProjectCommunities.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentEditProjectCommunities.vue?vue&type=style&index=0&id=022801ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022801ca",
  null
  
)

export default component.exports